import React, { useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "./banner.scss";
import { trackBannerClicked } from "../../utils/mixpanel";

const BannerServices = ({ className, headerImages, isFirst, isVideo }) => {
  console.log("headerImagesssss", headerImages);
  return (
    <div className={className}>
      <Carousel
        className="banner banner-services noSelect mb-2"
        swipeable={true}
        autoPlay
        infiniteLoop={true}
        showIndicators={false}
        showArrows={false}
        showThumbs={false}
        emulateTouch={true}
      >
        {headerImages?.map((slide) => {
          return (
            <div
              className="carousel-item-custom noSelect"
              data-interval={3000}
              onClick={() => trackBannerClicked({ banner_image: slide, banner_url: "" })}
            >
              <img src={slide} alt="Slide" />
            </div>
          );
        })}
      </Carousel>
    </div>
  );
};

export default BannerServices;
